import { render, staticRenderFns } from "./PromotionBlog.vue?vue&type=template&id=0005c098&scoped=true"
import script from "./PromotionBlog.vue?vue&type=script&lang=js"
export * from "./PromotionBlog.vue?vue&type=script&lang=js"
import style0 from "./PromotionBlog.vue?vue&type=style&index=0&id=0005c098&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005c098",
  null
  
)

export default component.exports